module.exports = __webpack_public_path__ + "img/file_import_history.3c1a46fa.png";